module.exports = __webpack_public_path__ + "static/media/placard.2b605fb5.webp";